module.exports = __webpack_public_path__ + "img/ly.fd21eb15.png";